import {SnackbarStatus} from "../../shared/providers/SnackbarContext";

const saveFile = async (blob: Blob, name: string) => {
    const a = document.createElement('a');
    a.download = name;
    a.href = URL.createObjectURL(blob);
    a.addEventListener('click', () => {
        setTimeout(() => URL.revokeObjectURL(a.href), 30 * 1000);
    });
    a.click();
};

export async function downloadPODCorrectionsCSV(data: any[], snackbarCtx: any) {
    try {
        const headers = [
            "Qualifies for STP",
            "New POD Nbr",
            "POD Nbr",
            "New POD Ctry",
            "POD Ctry",
            "New POD STP",
            "POD STP",
            "Master Data STP",
            "To Be Deleted",
            "MCO",
            "FCI",
            "Container",
            "CRPO",
            "CRPO Line",
            "Material",
            "Units"
        ];
        const rows = data.map(row => [
            row.stpQualifier ?? "",
            row.newPodNumber ?? "",
            row.podNumber ?? "",
            row.newDestinationCountry ?? "",
            row.destinationCountry ?? "",
            row.newStpCode ?? "",
            row.stpCode ?? "",
            row.stpCodeMasterData ?? "",
            row.toBeDeleted ? "Y" : "N",
            row.materialCountryOfOrigin ?? "",
            row.factoryCommercialInvoiceNumber ?? "",
            row.transportEquipmentNumber ?? "",
            row.purchaseOrderNumber ?? "",
            row.purchaseOrderLineNumber ?? "",
            row.productCode ?? "",
            row.quantity ?? "",
        ]);
        const csvContent = [
            headers.join(","),
            ...rows.map(r => r.map(v => `"${String(v).replace(/"/g, '""')}"`).join(","))
        ].join("\n");
        const blob = new Blob([csvContent], {type: "text/csv"});
        await saveFile(blob, "pod-corrections.csv");
    } catch (e) {
        snackbarCtx.displayMsg("Failed to download CSV", SnackbarStatus.error);
    }
}

export async function downloadCertificateReportCsv(downloadCertificateReportCsvProps) {
    const {
        departureDateFrom,
        departureDateTo,
        manufacturerCountryOfOrigins,
        podNumberFilled,
        transportationModes,
        forwarders,
        data,
        snackbarCtx
    } = downloadCertificateReportCsvProps;

    try {
        const headers = [
            "TRANSPORTATION_MODE",
            "MCO",
            "CARRIER",
            "FORWARDER",
            "CONTAINER_NBR",
            "BOL",
            "SHIPMENT_TYPE",
            "DESTINATION_COUNTRY",
            "DEPARTURE_DATE",
            "DISCHARGE_DATE",
            "PODNBR",
            "FACTORY_CODE",
            "INVOICENBR",
            "PRODUCT_CD",
            "PO_NBR",
            "PO_ITEM_NBR"
        ];
        const rows = data.map(row => [
            row.delivery?.transportationMode ?? "",
            row.delivery?.materialCountryOfOrigin ?? "",
            row.delivery?.carrier ?? "",
            row.delivery?.forwarder ?? "",
            row.delivery?.transportEquipmentNumber ?? "",
            row.delivery?.billOfLadingNumber ?? "",
            row.delivery?.shipmentType ?? "",
            row.preferentialOriginDocument?.destinationCountry ?? "",
            row.delivery?.departureDate ?? "",
            row.delivery?.dischargeDate ?? "",
            row.preferentialOriginDocument?.number ?? "",
            row.delivery?.factoryCode ?? "",
            row.delivery?.factoryCommercialInvoiceNumber ?? "",
            row.delivery?.productCode ?? "",
            row.delivery?.purchaseOrderNumber ?? "",
            row.delivery?.purchaseOrderLineNumber ?? ""
        ]);

        const csvContent = [
            "Report Criteria:",
            `Departure Date (from):; ${departureDateFrom ? new Date(departureDateFrom).toISOString().slice(0, 10) : ""}`,
            `Departure Date (to):; ${departureDateTo ? new Date(departureDateTo).toISOString().slice(0, 10) : ""}`,
            `Manufacturer Country of Origins:; ${manufacturerCountryOfOrigins}`,
            `POD Number Filled:; ${podNumberFilled}`,
            `Transportation Modes:; ${transportationModes}`,
            `Forwarders:; ${forwarders}`,

            headers.join(";"),

            ...rows.map(r => r.map(v => `"${String(v).replace(/"/g, '""')}"`).join(";"))
        ].join("\n");

        const blob = new Blob([csvContent], {type: "text/csv"});
        await saveFile(blob, "certificate-report.csv");
    } catch (e) {
        snackbarCtx.displayMsg("Failed to download CSV", SnackbarStatus.error);
    }
}
